import i18n from "config/i18next";

i18n.addResources("es", "tableSlots", {
  region: "Región",
  workzone: "Zona de operación",
  capacity: "Capacidad",
  shift: "Horario",
  date: "Fecha",
});
